module.exports = __webpack_public_path__ + "media/packs/images/details/cost-8bf5056e3de701cc0339cab107e1e7cf.svg";